/**
 * @generated SignedSource<<b80fbefe575dcb65565c854b790d916a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BlogPostStatusEnum = "approved" | "draft" | "published";
import { FragmentRefs } from "relay-runtime";
export type BlogPostListItem_BlogPost$data = {
  readonly excerpt: string | null | undefined;
  readonly id: string;
  readonly slug: string | null | undefined;
  readonly status: BlogPostStatusEnum | null | undefined;
  readonly user: {
    readonly profile: {
      readonly slug: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostItem_BlogPost">;
  readonly " $fragmentType": "BlogPostListItem_BlogPost";
};
export type BlogPostListItem_BlogPost$key = {
  readonly " $data"?: BlogPostListItem_BlogPost$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostListItem_BlogPost">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogPostListItem_BlogPost",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BlogPostItem_BlogPost"
    }
  ],
  "type": "BlogPost",
  "abstractKey": null
};
})();

(node as any).hash = "10ba6e1b1912eec86ec5f2f69b54327d";

export default node;
